"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _arrays = require("../../utils/arrays");
var _objects = require("../../utils/objects");
var _assets = require("../../utils/assets");
var assetsActions = _interopRequireWildcard(require("../assets/actionTypes"));
var pagesActions = _interopRequireWildcard(require("../pages/actionTypes"));
var actions = _interopRequireWildcard(require("./actionTypes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  data: {},
  ui: {}
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var publishedVersion = (0, _assets.getGAMKey)(action);
  var draftVersion = "".concat(publishedVersion, "/draft");
  var versionPath = "".concat(action.isDraft ? draftVersion : publishedVersion);
  switch (action.type) {
    case pagesActions.CREATE_PAGE.REQUEST:
      {
        var _state$data$versionPa;
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, state.data[versionPath]), {}, {
            pages: (((_state$data$versionPa = state.data[versionPath]) === null || _state$data$versionPa === void 0 ? void 0 : _state$data$versionPa.pages) || []).concat([{
              path: action.pagePath,
              name: action.pageName
            }])
          })))
        });
      }
    case pagesActions.CREATE_PAGE.SUCCESS:
      {
        var _state$data$versionPa2, _state$data$versionPa3;
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, state.data[versionPath]), {}, {
            pages: ((_state$data$versionPa2 = (_state$data$versionPa3 = state.data[versionPath]) === null || _state$data$versionPa3 === void 0 ? void 0 : _state$data$versionPa3.pages) !== null && _state$data$versionPa2 !== void 0 ? _state$data$versionPa2 : []).filter(function (page) {
              return page.path !== action.initialPath;
            }).concat([{
              path: action.pagePath,
              name: action.pageName
            }])
          })))
        });
      }
    case actions.ORDER_PAGES.REQUEST:
      {
        var path = "".concat(action.params.isDraft ? draftVersion : publishedVersion);
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, path, _objectSpread(_objectSpread({}, state.data[path]), {}, {
            pages: action.params.pages
          })))
        });
      }
    case actions.ORDER_PAGES.SUCCESS:
      {
        var _path = "".concat(action.params.isDraft ? draftVersion : publishedVersion);
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, _path, _objectSpread(_objectSpread({}, state.data[_path]), {}, {
            pagesOrderRevision: action.result.pagesOrderRevision
          })))
        });
      }
    case actions.ORDER_PAGES.FAILURE:
      {
        var _path2 = "".concat(action.params.isDraft ? draftVersion : publishedVersion);
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, _path2, _objectSpread(_objectSpread({}, state.data[_path2]), {}, {
            pages: action.params.currentPages
          })))
        });
      }
    case actions.FETCH_PORTAL_SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, action.data), {}, {
            pages: action.data.pages
          })))
        });
      }
    case actions.PUBLISH_PORTAL.REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isPublishing: true
          })
        });
      }
    case actions.PUBLISH_PORTAL.SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isPublishing: false
          }),
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, publishedVersion, _objectSpread(_objectSpread({}, state.data[publishedVersion]), {}, {
            pages: state.data[draftVersion].pages,
            draftStatus: 'PUBLISHED'
          })), draftVersion, _objectSpread(_objectSpread({}, state.data[draftVersion]), {}, {
            draftStatus: 'PUBLISHED'
          })))
        });
      }
    case actions.PUBLISH_PORTAL.FAILURE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isPublishing: false
          })
        });
      }
    case actions.DISCARD_PORTAL_DRAFT.SUCCESS:
      {
        var versionKey = (0, _assets.getGAMKey)(action.params);
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread({}, (0, _objects.omit)(state.data, "".concat(versionKey, "/draft"), versionKey))
        });
      }
    case pagesActions.CREATE_PAGE.FAILURE:
      {
        var currentPages = state.data[versionPath].pages;
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, state.data[versionPath]), {}, {
            pages: currentPages.slice(0, currentPages.length - 1)
          })))
        });
      }
    case pagesActions.RENAME_PAGE.SUCCESS:
      {
        var _currentPages = state.data[versionPath].pages;
        var pagePosition = _currentPages.findIndex(function (page) {
          return page.path === action.oldPagePath;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, state.data[versionPath]), {}, {
            pages: (0, _arrays.replaceInArray)(_currentPages, {
              path: action.pagePath,
              name: action.pageName
            }, {
              index: pagePosition
            })
          })))
        });
      }
    case pagesActions.DELETE_PAGE.REQUEST:
      {
        var _currentPages2 = state.data[versionPath].pages;
        var _pagePosition = _currentPages2.findIndex(function (page) {
          return page.path === action.pagePath;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, state.data[versionPath]), {}, {
            pages: (0, _arrays.removeFromArray)(_currentPages2, {
              index: _pagePosition
            })
          })))
        });
      }
    case pagesActions.SAVE_PAGE.SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, publishedVersion, _objectSpread(_objectSpread({}, state.data[publishedVersion]), {}, {
            draftStatus: 'NOT_PUBLISHED'
          })), draftVersion, _objectSpread(_objectSpread({}, state.data[draftVersion]), {}, {
            draftStatus: 'NOT_PUBLISHED'
          })))
        });
      }
    case assetsActions.DELETE_ASSET.SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread({}, (0, _objects.omit)(state.data, draftVersion, publishedVersion))
        });
      }
    case actions.PORTAL_LOADING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isPortalLoading: true
          })
        });
      }
    case actions.PORTAL_LOADED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isPortalLoading: false
          })
        });
      }
    case actions.PAGE_LOADING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isPageLoading: true
          })
        });
      }
    case actions.PAGE_LOADED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isPageLoading: false
          })
        });
      }
    case actions.ASSET_LOADING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isAssetLoading: true
          })
        });
      }
    case actions.ASSET_LOADED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isAssetLoading: false
          })
        });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map